<template>
	<UiElement class="d-flex flex-column h-100" :settings="general.appearance.body.settings">
		<div class="d-none" style="position: fixed; left: 0; top: 0; background: #fcfcfc">
			<p>showLogo: {{ showLogo }}</p>

			<p>logo: {{ logo }}</p>

			<p>general.elements.logo: {{ general.elements.logo }}</p>
		</div>

		<UiElement :settings="general.elements.logo.settings" class="mb-5">
			<img
				v-if="showLogo && logo"
				:src="logo"
				class="w-100 h-100"
				alt=""
			/>

			<img
				v-else
				src="/images/logo_fallbach.png"
				class="w-100 h-100"
				alt=""
			/>
		</UiElement>

		<div class="row">
			<div class="col-6 mb-4">
				<div class="d-flex flex-column mb-4">
					<h4 class="mb-3">
						{{ general.elements.buttonFilled.label }}
					</h4>

					<UiButton :settings="general.elements.buttonFilled.settings">
						BUTTON
					</UiButton>
				</div>

				<div class="d-flex flex-column">
					<h4 class="mb-3">
						{{ general.elements.buttonFilled.label }} (Active)
					</h4>

					<UiButton :settings="general.elements.buttonFilled.settings" active>
						BUTTON
					</UiButton>
				</div>
			</div>

			<div class="col-6 mb-4">
				<div class="d-flex flex-column mb-4">
					<h4 class="mb-3">
						{{ general.elements.buttonOutlined.label }}
					</h4>

					<UiButton :settings="general.elements.buttonOutlined.settings">
						BUTTON
					</UiButton>
				</div>

				<div class="d-flex flex-column">
					<h4 class="mb-3">
						{{ general.elements.buttonOutlined.label }} (Active)
					</h4>

					<UiButton :settings="general.elements.buttonOutlined.settings" active>
						BUTTON
					</UiButton>
				</div>
			</div>
		</div>

		<div class="row mb-5">
			<div class="col-6">
				<div class="d-flex flex-column">
					<h4 class="mb-3">
						{{ general.elements.buttonOutlined.label }}
					</h4>

					<UiButtonArrow
						:settings="general.elements.buttonArrowOutlined.settings" :body="general.appearance.body.settings"
					>
						BUTTON
					</UiButtonArrow>
				</div>
			</div>

			<div class="col-6">
				<div class="d-flex flex-column">
					<h4 class="mb-3">
						{{ general.elements.buttonArrowFilled.label }}
					</h4>

					<UiButtonArrow
						:settings="general.elements.buttonArrowFilled.settings" :body="general.appearance.body.settings" right
					>
						BUTTON
					</UiButtonArrow>
				</div>
			</div>
		</div>

		<div class="row mb-5">
			<div class="col-6">
				<h4 class="mb-3">
					{{ general.elements.buttonLanguage.label }} (Variants A / B)
				</h4>

				<UiButtonLanguage :settings="general.elements.buttonLanguage.settings" />
			</div>

			<div class="col-6">
				<h4 class="mb-3">{{ general.elements.buttonAmount1.label }} (Variants A / B)</h4>

				<UiButtonAmount
					:settings="general.elements.buttonAmount1.settings"
					:product="{ label: 'Test Product 1', id: 0, price: 100 }"
				>
					<template #default="{ count }">
						<UiText :settings="general.elements.heading4.settings">
							{{ count }}
						</UiText>
					</template>
				</UiButtonAmount>

				<UiButtonAmount
					:settings="general.elements.buttonAmount2.settings"
					:product="{ label: 'Test Product 1', id: 0, price: 100 }"
				>
					<template #default="{ count }">
						<UiText :settings="general.elements.heading4.settings">
							{{ count }}
						</UiText>
					</template>
				</UiButtonAmount>
			</div>
		</div>

		<div>
			<div class="mb-4">
				<h4 class="mb-3">
					{{ general.elements.heading1.label }}
				</h4>

				<UiText :settings="general.elements.heading1.settings">H1, Lorem ipsum dolor</UiText>
			</div>

			<div class="mb-4">
				<h4 class="mb-3">
					{{ general.elements.heading2.label }}
				</h4>

				<UiText :settings="general.elements.heading2.settings">H2, Lorem ipsum dolor</UiText>
			</div>

			<div class="mb-4">
				<h4 class="mb-3">
					{{ general.elements.heading3.label }}
				</h4>

				<UiText :settings="general.elements.heading3.settings">H3, Lorem ipsum dolor</UiText>
			</div>

			<div class="mb-4">
				<h4 class="mb-3">
					{{ general.elements.heading4.label }}
				</h4>

				<UiText :settings="general.elements.heading4.settings">H4, Lorem ipsum dolor</UiText>
			</div>
		</div>

		<div>
			<h4 class="mb-3">
				{{ general.elements.progress1.label }}
			</h4>

			<UiProgress :settings="general.elements.progress1.settings" :progress="25" class="mb-5" />

			<UiProgress :settings="general.elements.progress1.settings" :progress="50" class="mb-5" />

			<UiProgress :settings="general.elements.progress1.settings" :progress="100" />
		</div>

		<UiDialog v-if="dialog">
			<template #default="{ onSubmit }">
				<UiElement :settings="dialog.appearance.body.settings">
					<div class="d-flex flex-column align-items-center justify-content-center">
						<UiText :settings="heading1" class="text-center">
							<template v-if="dialogKey === 'dialogMaxCount'">
								{{ translations?.maxProductsCount || '{maxProductsCount}' }}
							</template>

							<template v-else-if="dialogKey === 'dialogKioskTimeout'">
								{{ translations?.keepOrder || '{keepOrder}' }}
							</template>

							<template v-else>
								{{ translations?.noProductsAdded || '{noProductsAdded}' }}
							</template>
						</UiText>

						<UiButton :settings="button1" @click="onSubmit">
							{{
								dialogKey === 'dialogKioskTimeout'
									? (translations?.proceed || '{proceed}')
									: (translations?.ok || '{ok}')
							}}
						</UiButton>

						<div v-if="dialogKey === 'dialogKioskTimeout'" class="py-4"/>

						<UiButton v-if="button2" :settings="button2" @click="onSubmit">
							Zrusit objednavku
						</UiButton>
					</div>
				</UiElement>
			</template>
		</UiDialog>
	</UiElement>
</template>

<script setup>
	import { ref, computed, watch, onMounted } from 'vue';
	import { storeToRefs } from 'pinia';
	import { useThemeStore } from '@/stores/useThemeStore';
	import UiElement from '@/components/UI/UiElement.vue';
	import UiButton from '@/components/UI/UiButton.vue';
	import UiText from '@/components/UI/UiText.vue';
	import UiProgress from '@/components/UI/UiProgress.vue';
	import UiButtonArrow from '@/components/UI/UiButtonArrow.vue';
	import UiButtonAmount from '@/components/UI/UiButtonAmount.vue';
	import UiDialog from '@/components/UI/UiDialog.vue';
	import UiButtonLanguage from '@/components/UI/UiButtonLanguage.vue';
	import router from '@/router';
	import { useInheritedSettings } from '@/composables/useInheritedSettings';
	import { useTranslationsStore } from '@/stores/useTranslationsStore';

	const translationsStore = useTranslationsStore();

	const { translations } = storeToRefs(translationsStore);
	const themeStore = useThemeStore();
	const { theme } = storeToRefs(themeStore);
	const logo = ref(null);
	const showLogo = ref(true);

	const general = computed(() => theme.value.general);

	const dialogKey = computed(() => {
		return router?.currentRoute.value.query?.dialog || null;
	});

	const dialog = computed(() => {
		if (!dialogKey.value) return;

		return theme.value.pages[dialogKey.value];
	});

	const heading1 = dialog.value ? useInheritedSettings(computed(() => dialog.value.elements?.heading1)) : null;
	const button1 = dialog.value ? useInheritedSettings(computed(() => dialog.value.elements?.button1)) : null;
	const button2 = dialog.value ? useInheritedSettings(computed(() => dialog.value.elements?.button2)) : null;

	const encodedImage = computed(() => {
		if (!general.value.elements.logo.settings.image) return null;
		return general.value.elements.logo.settings.image;
	});

	watch(encodedImage, (val) => {
		if (!val) {
			showLogo.value = false;
			return;
		}

		showLogo.value = false;

		setTimeout(() => {
			logo.value = val;
			showLogo.value = true;
		}, 150);
	});

	onMounted(() => {
		if (general.value.elements.logo.settings.image) {
			logo.value = general.value.elements.logo.settings.image;
			showLogo.value = true;
		}
	});
</script>